import { render } from "./alert.vue?vue&type=template&id=99cbe170&scoped=true"
import script from "./alert.vue?vue&type=script&lang=js"
export * from "./alert.vue?vue&type=script&lang=js"

import "./alert.vue?vue&type=style&index=0&id=99cbe170&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99cbe170"]])

export default __exports__